import {mapActions} from 'vuex'
import {CHANNELS} from '../../store/modulesNames'
import {ACT_CHANGE_CHANNEL_USERS, ACT_DELETE_CHANNEL_USERS} from '../../store/actionsTypes'

export default {
    methods: {
        _findChannelMember(cid) {
            return this.all_members.find((member) => member.cid === cid)
        },
        _setMemberUserPrivilege({cid, privilege}) {
            const channelMember = this._findChannelMember(cid)
            const status = (channelMember || {}).status
            this.modalOpen({
                name: 'confirm',
                props: {
                    text: this.$t('member-rights-conf'),
                    btnOk: {
                        cb: async () => {
                            await this[ACT_CHANGE_CHANNEL_USERS]({
                                chId: this._channel_data.chId,
                                contacts: [{
                                    cid,
                                    privilege,
                                    status,
                                }],
                            })
                            if (channelMember) {
                                const { ADMIN, OWNER } = declarations.userPrivilege
                                const isAdminOrOwner = (priv) => [ADMIN, OWNER].includes(priv)

                                const currentArray = isAdminOrOwner(channelMember.privilege) ? this._admin_members : this._user_members
                                const targetArray  = isAdminOrOwner(privilege) ? this._admin_members : this._user_members

                                const memberIndex = currentArray.findIndex(member => member.cid === cid)
                                const member = currentArray[memberIndex]

                                if (member) {
                                    member.privilege = privilege
                                    channelMember.privilege = privilege

                                    if (currentArray !== targetArray) {
                                        currentArray.splice(memberIndex, 1)
                                        targetArray.push(member)
                                    }
                                }
                            }
                        },
                    },
                },
            })
        },
        _delMember(cid) {
            this.modalOpen({
                name: 'confirm',
                props: {
                    text: this.$t('delete-member-conf'),
                    btnOk: {
                        cb: async () => {
                            await this[ACT_DELETE_CHANNEL_USERS]({chId: this._channel_data.chId, contacts: [{cid}]})
                            const member = this._findChannelMember(cid)
                            if (member) { 
                                this.all_members.splice(this.all_members.indexOf(member), 1)
                            }
                        },
                    },
                },
            })
        },
        ...mapActions(CHANNELS, [ACT_CHANGE_CHANNEL_USERS, ACT_DELETE_CHANNEL_USERS]),
    },
}